import { Center, CenterProps } from "@chakra-ui/react";

export const ArrowIcon = ({ ...rest }: CenterProps) => {
  return (
    <Center color="#F15A22" {...rest}>
      <svg
        width="8"
        height="14"
        viewBox="0 0 8 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 13L7 7L1 1"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Center>
  );
};
